import { SET_TRANSACTION_HISTORY_OFFICE } from './types'
import { getTransactionHistoryOffice } from '@/http/transaction';

export default {
  async setTransactionHistoryOffice({ commit }, data) {
    const history = await getTransactionHistoryOffice(data.fromDate, data.toDate);
    commit(SET_TRANSACTION_HISTORY_OFFICE, history.data.pageItems);
    return history;
  }
}
